import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  /**
   * Emits on window resize event.
   */
  resize$ = fromEvent(window, 'resize');

  // TODO: use CDK BreakpointObserver
  isMobileView$ = this.resize$.pipe(
    startWith({ currentTarget: window }),
    map((val: Event) => {
      const window = val.currentTarget as Window;
      return window.innerWidth < this.mobileBreakpoint.width;
    }),
  );

  mobileBreakpoint = {
    width: null,
  };

  /**
   * Default style breakpoint from variables.scss
   * below this breakpoint we assume the device is mobile (tablet, phone)
   * Value in rem
   */
  private mobileBreakpointOriginal = {
    width: 62,
  };

  /**
   * default project set up for rems
   */
  private defaultRemRate = 16;

  constructor() {
    this.mobileBreakpoint = {
      width: this.convertRemToPx(this.mobileBreakpointOriginal.width),
    };
  }

  /**
   * Convert rem to px
   * @param rems number in rems
   * @return value in px
   */
  convertRemToPx(rems: number): number {
    return rems * this.defaultRemRate;
  }
}
